module.exports = __webpack_public_path__ + "media/images/pic/talk-f13fdc7e53d52989b5a6e7f6e091a6bb.jpg";